﻿let authForm = {};

authForm = {
	el: {
		root: document.querySelector(".auth-form"),
		navButtons: document.querySelectorAll(".auth-form__nav-button"),
		forms: document.querySelectorAll(".auth-form__form"),
		methods: document.querySelector(".auth-form__method"),
		steps: document.querySelectorAll(".auth-form__step"),
		simForm: document.querySelector('.auth-form__form[data-method="sim"]'),
		appForm: document.querySelector('.auth-form__form[data-method="app"]'),
		message: document.querySelector(".auth-form__message"),
		inputs: document.querySelectorAll(".auth-form .auth-form__input"),
		challengeText: document.querySelector(".auth-form__challenge-text"),
    banner: document.querySelector(".banner")

	},
	init: function() {
    this.handleNav();
		this.formEvents();
		this.inputEvents();
    
    if (this.el.banner) {
      this.handleBanner(this.el.banner);
      window.addEventListener('resize', () => this.handleBanner(this.el.banner))
    }
	},
  handleBanner(banner) {
    const bannerText = banner.querySelector('.banner__subcaption')
    if (bannerText) {
      if (window.innerWidth < 776) {
        bannerText.style.display = "none";
        banner.style = "padding-top: 100px;"
      }
      else {
        bannerText.style.display = "block";
        banner.style = "padding-top: 210px;"
      }
    }
  },

	handleSubmit(form) {
		form.addEventListener("submit", (e) => {
			e.preventDefault();
      console.log('submitting')

      const submitBtn = form.querySelector('button[type="submit"]')
      if (submitBtn) {
        submitBtn.classList.add("button--disabled");

        const spinner = submitBtn.querySelector('.spinner')
        spinner.classList.remove('hide')
        spinner.style.display = "block";

        const btnText = submitBtn.querySelector('.button__text')
        btnText.style.visibility = "hidden";
      }
			try {
				// biome-ignore lint/complexity/useLiteralKeys: <explanation>
				const antiforgeryToken = form["__RequestVerificationToken"].value;
        const formData = this.getFormData(form)
        const data = {
          culture: formData['culture'],
          authType: formData['authType'],
          id: formData['id'],
          phone: formData['phone'] ? formData['phone'] : '',
          ssn: formData['ssn'] ? formData['ssn'] : '',
          ufprt: formData['ufprt']
        }
				fetch("/umbraco/surface/mypagesauth/login", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						RequestVerificationToken: antiforgeryToken,
					},
					body: JSON.stringify(data),
				}).then((response) => {
          if (!response.ok) {
            console.error("[auth-form | submit | !response.ok]");
            this.handleMessage(true, "error");
            return;
          }
          return response.json().then((data) => {
            this.poll(data, antiforgeryToken, form)
          })
        })
				
			} catch (error) {
				console.error("[auth-form | catcn | error]", error);
			}
		});
	},
	poll(res, antiforgeryToken, form) {
		this.changeStep(2, res);
		const redirect = form.querySelector('input[name="id"]').value;

    const submitBtn = form.querySelector('button[type="submit"]')
    const submitBtnText = submitBtn.querySelector('.button__text')
    const spinner = submitBtn.querySelector('.spinner')

		fetch("/umbraco/surface/mypagesauth/poll", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				RequestVerificationToken: antiforgeryToken,
			},
			body: JSON.stringify({
				culture: "is-IS",
				authIdentifier: res.identifier,
				id: redirect,
			}),
		}).then((response) => {
      if (!response.ok) {
        console.error("[auth-form | poll | !req.ok]");
        submitBtnText.style.visibility = "visible"
        spinner.classList.add('hide')
        submitBtn.classList.remove("button--disabled")
        this.changeStep(1);
        this.handleMessage(true, "error");
        return;
      }
      return response.json().then((data) => {
        if (data.success) {
          window.location.href = window.location.origin + data.redirect;
        }
      })
    })
	},
	handleMessage(show = false, type = "error") {
		if (show) {
			this.el.message.style.display = "block";

			setTimeout(() => {
				this.el.message.style.display = "none";
			}, 10000);
		} else {
			this.el.message.style.display = "none";
		}

		this.el.message.classList.add(`message--${type}`);
	},
	getFormData(form) {
		const formData = new FormData(form);
		const plainFormData = {};
		// @ts-ignore
		for (const [key, value] of formData.entries()) {
			plainFormData[key] = value;
		}

		return plainFormData;
	},
	changeStep(stepNumber, request = null) {
		this.el.steps.forEach((step) => {
			step.style.display = "none";
		});
		const chosenStep = this.el.root.querySelector(
			`.auth-form__step[data-step="${stepNumber}"]`
		);
		if (chosenStep) {
			chosenStep.style.display = "block";
		}

		if (stepNumber === 2) {
			this.el.challengeText.innerText = request.challenge;
		}
	},
	handleNav() {
		this.el.navButtons.forEach((button) => {
			button.addEventListener(
				"click",
				(e) => {
					this.changeForm(e.target.dataset.method);
				},
			);
		});
	},
	changeForm(method) {
		this.el.forms.forEach((item) => {
			item.classList.remove("auth-form__form--active");
		});
		this.el.navButtons.forEach((button) => {
			button.classList.remove("auth-form__nav-button--active");
		});
    const methodForm = this.el.root.querySelector(`.auth-form__form[data-method="${method}"]`)
    const methodBtn = this.el.root.querySelector(`.auth-form__nav-button[data-method="${method}"]`)
		if (methodForm) {
			methodForm.classList.add("auth-form__form--active");
    }
    if (methodBtn) {
      methodBtn.classList.add("auth-form__nav-button--active");
    }
		
	},
	formEvents() {
    // not handling login__form here
    this.handleSubmit(this.el.simForm)
    this.handleSubmit(this.el.appForm)
	},
	inputEvents() {
		this.el.inputs.forEach((input) => {
			// This prevents ctrl + v
			input.onpaste = (e) => e.preventDefault();

			input.addEventListener(
				"keyup",
				(e) => {
					if (e.key !== "Backspace") {
						const regex = /^[0-9-]*$/;

						if (!regex.test(e.target.value)) {
							// If the input doesn't match the pattern, clear the input value
							e.target.value = e.target.value.replace(/[^0-9-]/g, "");
						}
					}

					const parent = e.target.closest(
						".auth-form__input-wrap"
					);

          if (parent) {
            const submitBtn = parent.querySelector(".auth-form__submit")
            if (submitBtn) {
              const inputLength = e.target.value.length;
              const maxLength = e.target.maxLength;
              const isSim = maxLength == 8;
              const isApp = maxLength == 11;
              if (inputLength == maxLength) {
                if ((isSim && e.target.value[3] == '-') || (isApp && e.target.value[6] == '-')) {
                  submitBtn.removeAttribute("disabled");
                } 
                else {
                  submitBtn.setAttribute("disabled", "");
                }
              } 
              else if (inputLength == maxLength - 1) {
                if (!e.target.value.includes('-')) {
                  
                  submitBtn.removeAttribute("disabled");
                } 
                else {
                  submitBtn.setAttribute("disabled", "");
                }
              }
              
              else {
                submitBtn.setAttribute("disabled", "");
              }

            }
          }

				},
			);
		});
	},
};

authForm.initialize = function () {
  authForm.init();
};

module.exports = authForm;
